import { useMutation } from '@tanstack/react-query'
import { useServer } from 'app/server/context'

export interface PreSignedUrl {
  url: string
  thumbnail_url?: string
  uuid: string
}

export interface PresignedUrlsVariables {
  conversationId: string
  count: number
  isFileSharing?: boolean
}

/**
 * Hook for getting presigned URLs for file uploads
 */
export function useGetPresignedUrls() {
  const { server } = useServer()

  return useMutation({
    mutationFn: async ({
      conversationId,
      count,
      isFileSharing = false,
    }: PresignedUrlsVariables) => {
      return server.get<PreSignedUrl[]>(
        `/v2/chat/${conversationId}/presigned-url?count=${count}&file_sharing=${isFileSharing}`,
        'user'
      )
    },
  })
}
